import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';
import { setupSplide } from '../../../js/global';

/**
 * Module Init
 */
(() => {
  const moduleSelector = '.hero-slider .splide';
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    const sliderList = query.querySelector('.splide__list');
    try {
      sliderList.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(sliderList.data);

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            <div class="image-wrapper">
              <img src="${item.backgroundImage}" alt="">
            </div>
            <div class="content-wrapper container">
              ${item.smallTitle?.trim() ? `<h4 class="small-title">${item.smallTitle}</h4>` : ''}
              ${item.title?.trim() ? `<h2 class="title">${item.title}</h2>` : ''}
              <div class="actions">
                ${item.buttonText?.trim() && item.buttonLink?.trim() ? `<a class="btn-custom secondary" href="${item.buttonLink}">${item.buttonText}</a>` : ''}
                ${item.buttonText2?.trim() && item.buttonLink2?.trim() ? `<a class="btn-custom secondary" href="${item.buttonLink2}">${item.buttonText2}</a>` : ''}
                </div>
            </div>
          </div>
        `);
      });

      const slider = new Splide(query, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        pagination: true,
        arrows: false,
        autoplay: true,
        interval: 8000,
        height: 820,
      });
      setupSplide(slider);
      slider.mount();
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

// Add class "container" to the slider pagination
(() => {
  const sliderPagination = document.querySelector('.hero-slider .splide__pagination');
  if (sliderPagination) {
    sliderPagination.classList.add('container');
  }
})();
